import {
  Typography,
  Stack,
  Container,
  useMediaQuery,
  Box,
} from "@mui/material";
import React, { useState } from "react";
import p from "./Media/infograph-top.png";
import mashawiri from "./Media/mashawiri.png";
import tarkiz from "./Media/tarkiz.png";
import findme from "./Media/find-me.png";
import sard from "./Media/SRD.png";
import eway from "./Media/eway.png";
import tamayouz from "./Media/altamaioz.png";
import flash from "./Media/flash-pay.png";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DialogComp from "./DialogComp";

export default function ProjectsImages() {
  const [open, setOpen] = useState(false);
  const matches = useMediaQuery("(min-width:1300px)");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleClick = () => {
    setOpen(true);
  };
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
      }}
      id={t("Our Projects")}
    >
      <Container>
        <Stack>
          <Typography
            sx={{
              color: "white",
              fontSize: "35px",
              marginTop: "50px",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {t("Our Projects")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={p}
              alt="img-1"
              style={{ width: "100%", position: "relative" }}
            />
            <Stack
              direction="row"
              gap={matches ? 9 : 2}
              sx={{
                position: matches ? "absolute" : "relative",
                top: matches ? "2250px" : "",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: matches ? "" : "wrap",
              }}
            >
              <a href="https://www.mashawiri.com/">
                <img
                  alt="img-2"
                  src={mashawiri}
                  style={{
                    height: matches ? "100px" : "60px",
                    width: matches ? "100px" : "60px",
                    cursor: "pointer",
                  }}
                  href="https://www.mashawiri.com/"
                />
              </a>
              <a href="https://tarkizschool.com/">
                <img
                  src={tarkiz}
                  alt="img-3"
                  style={{
                    height: matches ? "100px" : "60px",
                    width: matches ? "100px" : "60px",
                    cursor: "pointer",
                  }}
                />
              </a>

              <img
                alt="img-4"
                src={findme}
                onClick={() => {
                  handleClick();
                }}
                style={{
                  height: matches ? "100px" : "60px",
                  width: matches ? "100px" : "60px",
                  cursor: "pointer",
                }}
              />

              <p onClick={handleClick}>
                <img
                  alt="img-5"
                  src={sard}
                  style={{
                    height: matches ? "100px" : "60px",
                    width: matches ? "100px" : "60px",
                    cursor: "pointer",
                  }}
                />
              </p>
              <a href="https://ewaytaxi.com/">
                <img
                  alt="img-6"
                  src={eway}
                  style={{
                    height: matches ? "100px" : "60px",
                    width: matches ? "100px" : "60px",
                    cursor: "pointer",
                  }}
                />
              </a>
              <p onClick={handleClick}>
                <img
                  alt="img-7"
                  src={tamayouz}
                  style={{
                    height: matches ? "100px" : "60px",
                    width: matches ? "100px" : "60px",
                    cursor: "pointer",
                  }}
                />
              </p>
              <p onClick={handleClick}>
                <img
                  alt="img-8"
                  src={flash}
                  style={{
                    height: matches ? "100px" : "60px",
                    width: matches ? "100px" : "60px",
                    cursor: "pointer",
                  }}
                />
              </p>
            </Stack>
          </Box>
        </Stack>
      </Container>
      <DialogComp open={open} setOpen={setOpen} />
    </div>
  );
}
